import EmisorInfoStore from './EmisorInfoStore';
import EmisorListStore from './EmisorListStore';
import EmisorUpsertStore from './EmisorUpsertStore';
import EmisorExpiresStore from './EmisorExpiresStore';
import EmisorCsdUpdateStore from './EmisorCsdUpdateStore';
import EmisorSuggestionsStore from './EmisorSuggestionsStore';
import EmisorCustomizationStore from './EmisorCustomizationStore';

const EmisorStore = {
  info: EmisorInfoStore,
  list: EmisorListStore,
  csd: EmisorCsdUpdateStore,
  upsert: EmisorUpsertStore,
  expires: EmisorExpiresStore,
  suggestions: EmisorSuggestionsStore,
  customization: EmisorCustomizationStore,
};

export default EmisorStore;
